import placeHolder from './../../../images/placeholder.png';

export default function imgLazyLoader() {
  return {
    restrict: 'A',
    scope: {
      imgLazyLoader: '@',
      bgImg: '@'
    },
    link: (scope, element) => {
      if (scope.bgImg) {
        let elem = angular.element('<img />').attr('src', scope.imgLazyLoader);
        // element.css('background-image', 'url(' + placeHolder + ')');
        elem.one('load', () => {
          elem.remove();
          element.css('background-image', 'url(' + scope.imgLazyLoader + ')');
        });
      }
      else {
        element.attr('src', '');
        element.one('load', () => {
          element.attr('src', scope.imgLazyLoader);
        });
        element.one('error', () => element.attr('src', placeHolder));
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/app/components/img-lazy-loader/directive.js